export enum ESERVER_ERROR_CODE {
  AUTH_0000 = 'AUTH_0000', // auth error
  AUTH_0001 = 'AUTH_0001', // authorization is denied

  AUTH_0011 = 'AUTH_0011', // user already exists
  AUTH_0012 = 'AUTH_0012', // user does not exists
  AUTH_0013 = 'AUTH_0013', // user already registered
  AUTH_0014 = 'AUTH_0014', // user is inhouse authentication
  AUTH_0015 = 'AUTH_0015', // user is oauth authentication
  AUTH_0016 = 'AUTH_0016', // oauth candidate does not exists

  AUTH_0021 = 'AUTH_0021', // password does not match
  AUTH_0022 = 'AUTH_0022', // both current and new password are required
  AUTH_0023 = 'AUTH_0023', // current password is same as new password

  AUTH_0031 = 'AUTH_0031', // jwt does not exist
  AUTH_0032 = 'AUTH_0032', // jwt is invalid
  AUTH_0033 = 'AUTH_0033', // jwt is expired
  AUTH_0034 = 'AUTH_0034', // bearer token is invalid
  AUTH_0035 = 'AUTH_0035', // refresh token is invalid
  AUTH_0036 = 'AUTH_0036', // refresh token is expired

  AUTH_0041 = 'AUTH_0041', // oauth is invalid
  AUTH_0042 = 'AUTH_0042', // oauth mail does not match
  AUTH_0043 = 'AUTH_0043', // oauth state is invalid

  AUTH_0051 = 'AUTH_0051', // authentication code does not exist
  AUTH_0052 = 'AUTH_0052', // authentication code is invalid
  AUTH_0053 = 'AUTH_0053', // authentication code is expired
  AUTH_0054 = 'AUTH_0054', // authentication code is not verified
  AUTH_0055 = 'AUTH_0055', // authentication code is already verified

  CLIENT_0003 = 'CLIENT_0003', // data does not exists
  CLIENT_0005 = 'CLIENT_0005', // quota exceeded
  CLIENT_0006 = 'CLIENT_0006', // data is not processable
}

export enum ESCHEDULE_TYPE {
  YEAR = 'year',
  MONTH = 'month',
  DATE = 'date',
  HOUR = 'hour',
  MINUTE = 'minute',
}

export enum EENGLISH_MONTH {
  JAN = 'Jan',
  FEB = 'Feb',
  MAR = 'Mar',
  APR = 'Apr',
  MAY = 'May',
  JUN = 'Jun',
  JUL = 'Jul',
  AUG = 'Aug',
  SEP = 'Sep',
  OCT = 'Oct',
  NOV = 'Nov',
  DEC = 'Dec',
}
